import React from 'react'
import { OptionsContainer } from './styled-components'
import { Selector } from '@acorns/grove'

interface Option {
  title: string
  id: string
  testId: string
  bodyText?: string
}

interface Props {
  options: Option[]
  selectedOptions: {
    [key: string]: boolean
  }
  onSelectorClick: (id: string) => void
}

export const SelectionList = ({ options, selectedOptions, onSelectorClick }: Props) => {
  return (
    <OptionsContainer>
      {options.map((option, index) => {
        return (
          <Selector
            key={`selector-${index}`}
            isSelected={selectedOptions[option.id]}
            onClick={() => {
              onSelectorClick(option.id)
            }}
            testId={option.testId}
            title={option.title}
            bodyText={option.bodyText}
            id={option.id}
          />
        )
      })}
    </OptionsContainer>
  )
}
